/* Winners Grid — reveals hidden cards a batch at a time.
 *
 * Every card is already in the DOM; the ones past the section's initial count
 * ship without the `active` class and are hidden by CSS. Pressing the button
 * activates the next batch and, once nothing is left, removes itself.
 *
 * Abstract on purpose: it queries data attributes, not layout classes, so the
 * grid markup can change without touching this.
 */
class WinnersGrid extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-load-more]");
    if (!this.button) return;

    this.step = parseInt(this.dataset.step, 10) || 3;

    this.button.addEventListener("click", () => this.revealNext());
    this.syncButton();
  }

  get hidden_items() {
    return Array.from(this.querySelectorAll("[data-winner-item]")).filter(
      (item) => !item.classList.contains("active")
    );
  }

  revealNext() {
    this.hidden_items.slice(0, this.step).forEach((item) => {
      item.classList.add("active");
    });
    this.syncButton();
  }

  /* The button is only useful while something is still hidden. Moving focus
     off it first keeps keyboard users from landing on a detached element. */
  syncButton() {
    if (this.hidden_items.length) return;

    if (this.button.contains(document.activeElement)) {
      const revealed = this.querySelectorAll("[data-winner-item].active");
      const last = revealed[revealed.length - 1];
      if (last) {
        last.setAttribute("tabindex", "-1");
        last.focus();
      }
    }

    this.button.closest("[data-load-more-wrap]")?.remove();
  }
}

customElements.define("winners-grid", WinnersGrid);
